import React, { FC } from "react";
import { Card, CardContent, Typography, CardMedia } from "@mui/material";
import { useMediaQuery } from "@mui/material";

import Props from "./card.interface";
import General from '../../stores/GeneralStore'

const CardLeftPhoto: FC<Props> = ({ imageSrc, text }: Props) => {
  const mobile = useMediaQuery("(max-width: 768px)");
  return (
    <Card
      sx={{
        display: "flex",
        borderRadius: "0",
        flexGrow: 1,
        flexDirection: mobile ? "column" : "row",
        minHeight: "10rem",
      }}
    >
      <CardMedia
        component="img"
        image={imageSrc}
        alt=""
        sx={{
          width: "35%",
          objectFit:'fill',
          "@media (max-width: 780px)": {
            height: "50%",
            width: "100%",
          },
        }}
      />
      <CardContent
        sx={{
          backgroundColor: "#101E8E",
          color: "#FFF",
          padding: "18px 16px 18px 16px",
          width: "70%",
          "@media (max-width: 780px)": {
            height: "50%",
            width: "100%",
          },
        }}
      >
        <Typography
          component="div"
          variant="h5"
          sx={{
            width: "80%",
            margin: "auto",
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 'bold'
          }}
        >
          {text}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardLeftPhoto;
